import { PARCEIRO_CASHME_HOSTNAME } from '../constants/ClientUrls';

const CASHME_FAVICON = '/cashme-favicon.png';
const CASHME_TAB_TITLE = 'Parceiro CashMe';

function isCashMeHost(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.location.hostname === PARCEIRO_CASHME_HOSTNAME
  );
}

export function resolveFavicon(clientFavicon?: string): string | undefined {
  return isCashMeHost() ? CASHME_FAVICON : clientFavicon;
}

export function resolveTabTitle(tabTitle: string): string {
  return isCashMeHost() ? CASHME_TAB_TITLE : tabTitle;
}

export function applyHostBranding(): void {
  if (!isCashMeHost()) return;

  const link =
    document.querySelector<HTMLLinkElement>('link[rel="icon"]') ??
    document.head.appendChild(document.createElement('link'));

  link.rel = 'icon';
  link.type = 'image/png';
  link.href = CASHME_FAVICON;

  document.title = CASHME_TAB_TITLE;
}
